import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import SuerveyRepository from '@/repositories/suerveyRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSuerveyStore = defineStore({
    id: 'suervey',
    state: () => ({
        reservationPk: '',
        formPk: '',
        suerveyForm: [],
        suerveyFormAnswer: [],
    }),
    actions: {
        /**
         * アンケートフォーム取得処理
         */
        async getSuerveyForm(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const suerveyRepository = new SuerveyRepository();
            try {
                // アンケートフォーム取得APIをコールする。
                const response = await suerveyRepository.getSuerveyFormActionApi(API_URL, queryParam, idToken);
                // アンケートフォーム取得の判定処理では、200 OKのレスポンス結果のエラーフラグを一律エラーにせず、画面に返却する。
                this.suerveyForm = response.data;
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * アンケートフォーム登録処理
         */
        async putSuerveyForm(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const suerveyRepository = new SuerveyRepository();
            try {
                const response = await suerveyRepository.putSuerveyFormActionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.suerveyForm = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    // share: {
    //     enable: true,
    //   },
    persist: {
        //ローカルストレージに保存する場合
        // storage: localStorage
        storage: sessionStorage,
    },
});
